import { styled } from 'src/styles/stitches.config'

export const StyledServices = styled('div', {
    '@md': {
        width: 'calc(9 * $colWidth)',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
})
